import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip";


const EmotionModeToggle = ({ mode, setMode }) => {
    const handleToggle = () => {
        setMode(mode === "Classic" ? "Quick" : "Classic");
    };

    const tooltipText =
        mode === "Classic"
            ? "Switch to Quick Mode: Just the vibe. Pure feeling."
            : "Switch to Classic Mode: Like a letter — personal, structured, and thoughtful.";



    return (
        <div className="w-full text-center mb-2">

            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <span
                            className="cursor-pointer text-2xl"
                            onClick={handleToggle}
                            role="button"
                            aria-label="Toggle emotion mode"
                        >
                            <div className="text-sm font-medium text-gray-700 -mt-0 mb-0 text-center">

                                {mode === "Classic" ? "Switch to Quick ⚡" : "Switch to Classic ✍️"}
                            </div>


                        </span>
                    </TooltipTrigger>
                    <TooltipContent>{tooltipText}</TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
};

export default EmotionModeToggle;
